import React from 'react';

const SiteSeeContext = React.createContext('');
export default SiteSeeContext;
